import {Pipe, PipeTransform} from '@angular/core';
import {compare} from '@core/tools/utils';

@Pipe({
    name: 'sort',
    pure: false
})
export class SortPipe<T> implements PipeTransform {

    transform(arr: T[], field?: string, order = 1): any[] {
        if (!arr) {
            return arr;
        }
        if (field) {
            return arr.sort(compare(field, order));
        } else {
            return arr.sort(compare());
        }
    }

}
